import { useEffect, useState } from "react";

const slides = [
  {
    type: "text",
    text: "YOUR GUIDE TO A PLANT-BASED LIFESTYLE",
  },
  {
    type: "link",
    text: "SUBSCRIBE TO RECEIVE OFFERS",
    href: "#newsletter",
  },
];

const Announcement = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((current) => (current + 1) % slides.length);
    }, 3000);
    return () => clearInterval(timer);
  }, []);

  const show = (delta) => {
    setIndex((current) => (current + delta + slides.length) % slides.length);
  };

  const slide = slides[index];

  return (
    <div className="announcement_wrapper">
      <div className="page-width">
        <div className="announcement_inner_wrapper">
          <div className="announcement_slider">
            {slide.type === "link" ? (
              <a href={slide.href} className="announcement_text text-white">
                {slide.text}
              </a>
            ) : (
              <div className="announcement_text text-white">{slide.text}</div>
            )}
          </div>
          <div className="announcement_Arrows_wrapper">
            <button
              className="custom-arrow prev text-white"
              onClick={() => show(-1)}
              aria-label="Previous"
            >
              <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
                <path
                  d="M15 6 9 12l6 6"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                />
              </svg>
            </button>
            <button
              className="custom-arrow next text-white"
              onClick={() => show(1)}
              aria-label="Next"
            >
              <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
                <path
                  d="m9 6 6 6-6 6"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Announcement;
